import React from "react";

import { HashRouter as Router } from "react-router-dom";
import "./App.css";
import ChatListArea from "./chat_list_area/chat_list_area.js";
import MessageArea from "./message_area/message_area.js";
import { Alert, Toaster, Position } from "@blueprintjs/core";
import "normalize.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import IdleTimer from "react-idle-timer";
import Actions from "./actions.js";

import { Spinner } from "@blueprintjs/core";
import classNames from "classnames";
import SessionStorageUtilities from "./Utilities/SessionStorageUtilities";
import Agente from "./models/Agente";
import { handleCredentialError } from "./Utilities/authGuard";
// import firebase from 'firebase/app';
// import 'firebase/auth';
import CryptoJS from "crypto-js";
import { decodeEnv } from './Utilities/env.js';

export default class App extends React.Component {
  static LOG_IN_URL = "/signin";

  /**
   *
   * @param props
   * @constructor
   */
  constructor(props) {
    super(props);

    const tenantDB = SessionStorageUtilities.GET_TENANT_SESSION();
    if (!tenantDB) {
      window.location = App.LOG_IN_URL;
    }

    const icon = window.document.querySelector("link[rel='icon']");
    let agentImage = this.getTenantAgentImage(tenantDB);
    icon.href = "/images/favicon/heybanco.svg";
    switch (tenantDB) {
      case "banregio":
      case "banregiopago":
        icon.href = "/images/favicon/banregio.ico";
        break;
      default:
        break;
    }

    this.state = {
      currentAgent: Agente.NEW_INSTANCE_OR_NULL(
        SessionStorageUtilities.GET_USER_AGENT_SESSION(),
        tenantDB,
        [],
      ),
      agentImage: agentImage,
      tenant: tenantDB,
      currentConversation: null,
      messageList: [],
      contactList: [],
      contactListListener: [],
      messageListeners: {}, // Store references to message listeners by waid
      agentList: [],
      quickReplies: [],
      typification: [],
      templateList: [],
      attentionDays: [],
      permissions: [],
      parameter: {},
      broadcastListList: [],
      customerDirectory: [],
      alertMessage: {
        text: "Alerta",
        okButton: "Cerrar",
        icon: "info-sign",
        isOpen: false,
      },
      alertConversation: {
        text: "Alerta",
        okButton: "Archivar",
        cancelButton: "Después",
        icon: "archive",
        isOpen: false,
        isLogOut: false,
      },
      appIsLoading: false,
      loadingConversation: false,
      requireLogOut: false,
    };

    var firebaseConfig = {
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      apiKey: decodeEnv(process.env.REACT_APP_FIREBASE_API_KEY),
      authDomain: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
      databaseURL: `https://${tenantDB}-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseio.com`,
      storageBucket: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`,
      messagingSenderId: decodeEnv(process.env.REACT_APP_FIREBASE_MSG_SENDER_ID),
      appId: decodeEnv(process.env.REACT_APP_FIREBASE_APP_ID),
    };

    var firebaseConfigMes = {
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      apiKey: decodeEnv(process.env.REACT_APP_FIREBASE_API_KEY),
      authDomain: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
      databaseURL: `https://messaging-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseio.com`,
      storageBucket: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`,
      messagingSenderId: decodeEnv(process.env.REACT_APP_FIREBASE_MSG_SENDER_ID),
      appId: decodeEnv(process.env.REACT_APP_FIREBASE_APP_ID),
    };
    // Initialize Firebase
    // window.firebase.initializeApp(firebaseConfig);
    if (!window.firebase.apps.length) {
      window.firebase.initializeApp(firebaseConfig);
    }
    window.app2 = window.firebase.initializeApp(firebaseConfigMes, "app2");

    // const goLogin = SessionStorageUtilities.GET_GO_LOGIN_SESSION();
    // if(goLogin){
    //   SessionStorageUtilities.DELETE_GO_LOGIN_SESSION();

    //   // var googleProvider = new window.firebase.auth.GoogleAuthProvider();
    //   // const provider = new window.firebase.auth.GoogleAuthProvider();
    //   // provider.addScope('https://www.googleapis.com/auth/plus.login');
    //   // window.firebase.auth().signInWithRedirect(provider);
    //   // const signInWithRedirect = () => {
    //     // window.firebase.auth().signInWithRedirect(provider);
    //   // }

    //   // console.log(signInWithRedirect);

    //   // this.logIn()

    // }

    this.setCurrentConversation = this.setCurrentConversation.bind(this);
    this.logOut = this.logOut.bind(this);
    this.logIn = this.logIn.bind(this);
    this.setConection = this.setConection.bind(this);
    this.validateUser = this.validateUser.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.hideTimeOutConv = this.hideTimeOutConv.bind(this);
    this.viewTimeOutConv = this.viewTimeOutConv.bind(this);
    this.hideConversation = this.hideConversation.bind(this);
    this.setAgentToConversation = this.setAgentToConversation.bind(this);
    this.refHandlers = {
      toaster: (ref) => (this.toaster = ref),
    };

    this.idleTimer = null;
    this.idleTimer2 = null;
    this.handleOnIdle = this.handleOnIdle.bind(this);
    // this.handleOnAction = this.handleOnAction.bind(this)

    // window.setInterval(() => {
    //   const remainingTime = (this.idleTimer.getRemainingTime() / 1000).toFixed(0)
    //   document.title = `(${remainingTime}) Consola de atención a clientes / WhatsApp`
    // }, 1000)

    this.lastAlertHour = 0;
    this.maxTimeToArchive = 5; //hours
    this.haveOldConversations = this.haveOldConversations.bind(this);
    this.checkAndClose = this.checkAndClose.bind(this);
    this.checkConverationsTime = this.checkConverationsTime.bind(this);
    this.contactToArvive = 0;

    // Broadcast list
    this.createBroadcastList = this.createBroadcastList.bind(this);
    this.appendBroadcastListMembers =
      this.appendBroadcastListMembers.bind(this);
    this.loadBroadcastLists = this.loadBroadcastLists.bind(this);
    this.loadBroadcastListMembers = this.loadBroadcastListMembers.bind(this);
    this.removeBroadcastListMember = this.removeBroadcastListMember.bind(this);
    this.removeBroadcastList = this.removeBroadcastList.bind(this);

    // Load archive callback
    this.loadArchive = this.loadArchive.bind(this);
    this.setupMessageListeners = this.setupMessageListeners.bind(this);
    this.cleanupMessageListeners = this.cleanupMessageListeners.bind(this);
  }

  async logIn() {
    var googleProvider = new window.firebase.auth.GoogleAuthProvider();
    try {
      const result = await window.firebase
        .auth()
        .signInWithPopup(googleProvider);
      // El usuario ha iniciado sesión correctamente
      // console.log('User signed in: ', result.user);
      this.validateUser(result.user);
      window.app2.auth("app2").signInWithCredential(result.credential);
    } catch (error) {
      // Manejar errores aquí
      handleCredentialError(error);
      console.error("Error signing in: ", error);
    }
  }

  async refreshToken() {
    console.log("Refreshing token...");
    const user = window.firebase.auth().currentUser;
    if (user) {
      try {
        this.validateUser(user, true);
      } catch (error) {
        console.error("Error refreshing token:", error);
      }
    } else {
      console.log("No user is signed in");
    }
  }

  getTenantAgentImage(tenant) {
    let image = "/images/logos/heybanco.png";
    switch (tenant) {
      case "banregio":
      case "banregiopago":
        image = "/images/logos/banregio.png";
        break;
      default:
        break;
    }
    return image;
  }

  handleOnIdle(event) {
    console.log("user is idle");
    console.log("last active", this.idleTimer.getLastActiveTime());
    this.logOut();
  }

  // handleOnAction (event) {
  //   console.log('user did something', event)
  // }

  /**
   *
   * @param {string} conversationId
   */
  setMessageRead(conversationId) {
    const db = window.firebase.database();
    const ref = db.ref(`contacto/${conversationId}`);

    // Also update local state immediately
    const updatedContactList = this.state.contactList.map((contact) => {
      if (contact.id === conversationId) {
        return { ...contact, Unread: false };
      }
      return contact;
    });

    this.setState({ contactList: updatedContactList });

    ref.update({ Unread: false });
  }

  /**
   *
   * @param {string} text
   */
  showAlert(text) {
    var alert = this.state.alertMessage;
    alert.text = text;
    alert.isOpen = true;
    this.setState({ alertMessage: alert });
  }

  /**
   *
   * @param {string} text
   * @param {boolean} logOut
   */
  showAlertConversation(text, logOut) {
    var alert = this.state.alertConversation;
    alert.text = text;
    alert.isOpen = true;
    alert.isLogOut = logOut;
    this.setState({ alertConversation: alert });
  }
  viewTimeOutConv() {
    var alert = this.state.alertConversation;
    alert.isOpen = false;
    alert.isLonOut = false;
    this.setState({ alertConversation: alert });
    this.setCurrentConversation(this.contactToArvive);
    window.location = "#/conversation/" + this.contactToArvive;
  }

  hideAlert() {
    this.setState({ alertMessage: { isOpen: false } });
  }

  hideTimeOutConv() {
    var alert = this.state.alertConversation;
    alert.isOpen = false;
    if (alert.isLogOut) {
      this.logOut();
    }
    alert.isLonOut = false;
    this.setState({ alertConversation: alert });
  }

  /**
   *
   * @param {string} conversation
   * @param {string} agent
   */
  setAgentToConversation(conversation, agent) {
    let database = window.firebase.database();
    let contactReference = database.ref(`contacto/${conversation}`);
    contactReference.update({
      BrAgent: agent,
      UserLastChange: this.state.currentAgent.usuario.emailreal,
    });

    var userAgentEmail = this.state.currentAgent.usuario.emailreal.replace(
      /\./g,
      " ",
    );
    if (agent !== userAgentEmail) {
      window.location = "/";
    }
  }

  /**
   *
   * @param {string} key
   */
  hideConversation(key, keepCurrentView = false) {
    let newContactList = this.state.contactList.filter((contact) => {
      return contact.id !== key;
    });

    let newMessageList = this.state.messageList.filter((message) => {
      return message.sender !== key;
    });

    this.setState({
      contactList: newContactList,
      messageList: newMessageList,
    });

    if (!keepCurrentView && key === this.state.currentConversation) {
      // Mostrar la lista de contactos en dispositivos móviles
      const chatListArea = document.getElementById("chat-list-area");
      if (chatListArea) {
        chatListArea.classList.remove("hidden");
      }

      // Reset body overflow
      document.body.style.overflow = "";

      window.location = "/#";
    }
  }

  logOut() {
    var db = window.firebase.database();
    var userAgentEmail = this.state.currentAgent.usuario.emailreal.replace(
      /\./g,
      " ",
    );
    var myConnectionsRef = db.ref("usuario/" + userAgentEmail + "/conexiones");
    myConnectionsRef.remove();

    this.setState({ currentAgent: null });
    this.setState({ imageAgent: this.getTenantAgentImage(this.state.tenant) });
    window.firebase.auth().signOut();
    this.toaster.show({ message: "Cerro sesión" });
    SessionStorageUtilities.CLEAR();
    window.location = "/signin";
  }

  checkAndClose() {
    //console.log('checkAndClose')
    this.contactToArvive = this.haveOldConversations();
    if (this.contactToArvive) {
      this.showAlertConversation("antiguas sin archivar", true);
    } else {
      this.logOut();
    }
  }

  checkConverationsTime() {
    this.contactToArvive = this.haveOldConversations();
    if (this.contactToArvive) {
      this.showAlertConversation("antiguas sin archivar", false);
    }
  }

  haveOldConversations() {
    let result = null;
    let that = this;
    let cont = this.state.contactList.find(function (contact) {
      //console.log(contact);
      let expirationTime = window.countdown(
        contact.lastMessage.Inbound.Timestamp * 1000 +
          that.maxTimeToArchive * 60 * 60 * 1000,
        null,
        window.countdown.HOURS + window.countdown.MINUTES,
      );
      //console.log(expirationTime);
      if (
        that.state.currentAgent.usuario.emailreal.replace(/\./g, " ") ===
        contact.br_agent
      ) {
        return (
          that.state.currentAgent.usuario.emailreal.replace(/\./g, " ") ===
            contact.br_agent && expirationTime.value >= 0
        );
      } else {
        return null;
      }
    });
    //console.log(cont);
    if (cont) {
      result = cont.id;
    }
    return result;
  }

  /**
   *
   * @param userAgent
   */
  validateUser(userAgent, isRefresh = false) {
    let that = this;
    var db = window.firebase.database();
    var userAgentEmail = userAgent.email.replace(/\./g, " ");
    //console.log(userAgent);
    //userAgentEmail="andrea juarez@hey inc";
    //userAgentEmail="claudia bolado@banregio com";
    //alert(userAgent)
    var userRef = db.ref("usuario/" + userAgentEmail);
    var updateEmailReal = false;
    userRef.once("value", function (data) {
      let document = data.val();

      if (document != null && document.rol === Agente.ROLE_AGENTE_CALL_CENTER) {
        //if(document!=null){
        userAgent.usuario = document;
        // console.log(userAgent);
        // console.log(userAgent.stsTokenManager.accessToken);
        // console.log(that.state.currentAgent);
        //userAgent.email="andrea juarez@hey inc";
        userAgent.usuario.group = document.grupo;

        if (document.emailreal == null) {
          userAgent.usuario.emailreal = userAgent.email;
          updateEmailReal = true;
        }

        userAgent = Agente.NEW_INSTANCE_OR_NULL(
          userAgent,
          SessionStorageUtilities.GET_TENANT_SESSION(),
          [],
        );
        SessionStorageUtilities.SET_USER_AGENT_SESSION(userAgent);
        that.setState({ currentAgent: userAgent });
        that.setState({ agentImage: userAgent.photoURL });
        that.setConection(userAgentEmail);

        if (!isRefresh) {
          // console.log(userAgent);
          that.setState({ appIsLoading: true });
          Actions(that).loadContacts(db);
          //Actions(that).loadMessages(db)
          Actions(that).loadTemplates(db);
          Actions(that).updateContacts(db);
          //Actions(that).updateMessages(db)
          Actions(that).removeContacts(db);
          Actions(that).loadUsers(db);
          Actions(that).updateUsers(db);
          Actions(that).loadQuickReplies(userAgent.usuario.grupo);
          Actions(that).loadTypification(userAgent.usuario.grupo);
          Actions(that).loadParameter("EXECUTIVE_OUTOFSCHEDULE_PROMPT");
          Actions(that).loadAttentionsDays(userAgent.usuario.grupo);
          Actions(that)
            .loadPermissions(userAgent.usuario.grupo)
            .then((perms) => {
              userAgent = Agente.NEW_INSTANCE_OR_NULL(
                userAgent,
                SessionStorageUtilities.GET_TENANT_SESSION(),
                perms,
              );
              SessionStorageUtilities.SET_USER_AGENT_SESSION(userAgent);
              that.setState({ currentAgent: userAgent });
              that.setState({ agentImage: userAgent.photoURL });
              that.setConection(userAgentEmail);
            });
          Actions(that).loadBroadcastLists(userAgent.usuario.emailreal);
          Actions(that).loadFullDirectory(userAgent.usuario.idPromotor);
          /*
                  Actions(that).alterUser(db, 'ernesto.lara@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'manzur.vera@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'olga.garza@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'francisca.luna@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'francisco.limon@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'jorge.alvarez@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'miguel.cantu@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'jorge.samaniego@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'rubi.armendariz@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'rubi.armendariz@banregio.com', 'cobranza');
                  Actions(that).alterUser(db, 'luis.ramos@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'francisco.herrera@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'emma.castillo@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'adriana.guerrero@hey.inc', 'cobranza');
                  Actions(that).alterUser(db, 'alberto.almanza@hey.inc ', 'cobranza');
                  Actions(that).alterUser(db, 'ricardo.delacruz@hey.inc ', 'cobranza');
                  Actions(that).alterUser(db, 'juanenrique.lopez@hey.inc ', 'cobranza');
                  Actions(that).alterUser(db, 'ricardo.jimenez@hey.inc ', 'cobranza');
                  */
          /*
                  let template={
            "exportFields": "",
            "exportSample": "",
            "group": "lxp",
            "text": "Buen día, nos ponemos en contacto por parte de Hey Banco debido a la solicitud de crédito que realizó a través de nuestra app ¿Podemos continuar con el trámite?"
          }
                  Actions(that).addTemplate(db, 'heybanco_ventas_generica_01', template)
          
          
                  let template2={
            "exportFields": "CLIENTE",
            "exportSample": "Jose",
            "group": "lxp",
            "text": `Hey, {{1}}
          Recibimos tu interés en nuestro plan de Ayuda Hospitalaria y Consulta Virtual. 🩺
          ¿Quieres que continuemos con el proceso de contratación?`
          }
                  Actions(that).addTemplate(db, 'heybanco_ventas_05', template2)
          
                  
                  Actions(that).addTemplate(db, 'heybanco_ventas_06', {
            "exportFields": ",CLIENTE,AGENTE",
            "exportSample": ",Jose,Andres",
            "group": "lxp",
            "text": `Hey, {{1}}
          Soy {{2}}, tú asesor de seguros en Hey Banco. 
          Recibimos tu interés en el plan de Ayuda Hospitalaria y Consulta Virtual. 
          ¿Cómo puedo ayudarte?`
          }) 
                 
          
          */

          //Actions(that).deleteTemplate(db, 'id_template_v2', template)

          let userReference = db.ref(`usuario/${userAgentEmail}`);
          userReference.update({
            photoURL: userAgent.photoURL,
            nombre: userAgent.displayName,
          });

          if (updateEmailReal) {
            userReference.update({ emailreal: userAgent.usuario.emailreal });
          }
          that.checkConverationsTime();
        }
      } else {
        that.showAlert("Agente no registrado");
        //alert('Agente no registrado');
      }
    }, function (error) {
      handleCredentialError(error);
      console.error("Error validating user", error);
    });
  }

  setConection(userAgentEmail) {
    var db = window.firebase.database();
    //var userAgentEmail=this.state.currentAgent.email.replace(/\./g, " ");
    // since I can connect from multiple devices or browser tabs, we store each connection instance separately
    // any time that connectionsRef's value is null (i.e. has no children) I am offline
    var myConnectionsRef = db.ref("usuario/" + userAgentEmail + "/conexiones");

    // stores the timestamp of my last disconnect (the last time I was seen online)
    var lastOnlineRef = db.ref("usuario/" + userAgentEmail + "/cerroSesion");

    var connectedRef = db.ref(".info/connected");
    connectedRef.on("value", function (snap) {
      if (snap.val() === true) {
        // We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)
        var con = myConnectionsRef.push();
        // When I disconnect, remove this device
        con.onDisconnect().remove();

        // Add this device to my connections list
        // this value could contain info about the device or a timestamp too
        con.set(true);

        // When I disconnect, update the last time I was seen online
        lastOnlineRef
          .onDisconnect()
          .set(window.firebase.database.ServerValue.TIMESTAMP);
      }
    }, function (error) {
      handleCredentialError(error);
      console.error("Error monitoring Firebase connection", error);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.requireLogOut && this.state.requireLogOut) {
      this.logOut();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("jwt-error", this._jwtErrorHandler);
  }

  componentDidMount() {
    let that = this;

    this._jwtErrorHandler = () => that.logOut();
    window.addEventListener("jwt-error", this._jwtErrorHandler);

    if (that.state.currentAgent) {
      that.validateUser(that.state.currentAgent);
    }

    window.firebase
      .auth()
      .getRedirectResult()
      .then(function (result) {
        if (result.credential) {
          window.app2.auth("app2").signInWithCredential(result.credential);
        }
        // The signed-in user info.
        //console.log("getRedirectResult")
        if (result.user) {
          that.validateUser(result.user);
        }
      })
      .catch(function (error) {
        handleCredentialError(error);
        // Handle Errors here.
        var errorCode = error.code;
        // var errorMessage = error.message;
        // The email of the user's account used.
        // var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        // var credential = error.credential;
        // [START_EXCLUDE]
        if (errorCode === "auth/account-exists-with-different-credential") {
          alert(
            "You have already signed up with a different auth provider for that email.",
          );
          // If you are using multiple auth providers on your app you should handle linking
          // the user's accounts here.
        } else {
          console.error(error);
        }
        // [END_EXCLUDE]
      });
    // this.refreshTokenPeriodically();
  }

  refreshTokenPeriodically() {
    setInterval(() => this.refreshToken(), 30 * 60 * 1000); // Refresca el token cada 30 minutos
  }

  updateContactCallback(key, title, body) {
    var that = this;

    // Force component re-render on mobile to ensure unread indicators show
    this.forceUpdate();

    // Force list re-render after a small delay to ensure state changes are visible
    setTimeout(() => {
      this.forceUpdate();
    }, 100);

    // Check if Notification is available (not available in iOS Safari)
    if (
      typeof Notification !== "undefined" &&
      Notification.permission === "granted"
    ) {
      var instance = new Notification(title, {
        body: body,
      });

      instance.onclick = () => {
        window.parent.focus();
        window.focus();
        that.setCurrentConversation(key);
        window.location = `/#/conversation/${key}`;
      };
    }
  }

  setCurrentConversation(conversation, shouldAssign = true) {
    const bytes = CryptoJS.enc.Base64.parse(conversation).toString(
      CryptoJS.enc.Utf8,
    );
    const waIdHash = CryptoJS.AES.decrypt(
      bytes,
      "1F04iqoixAOvibnsDRt",
    ).toString(CryptoJS.enc.Utf8);
    
    // Clean up previous conversation's message listeners
    if (this.state.currentConversation && this.state.currentConversation !== waIdHash) {
      this.cleanupMessageListeners(this.state.currentConversation);
    }
    
    // Start loading animation
    this.setState({ loadingConversation: true });
    
    this.setMessageRead(waIdHash);

    if (shouldAssign) {
      this.setAgentToConversation(
        waIdHash,
        this.state.currentAgent.usuario.emailreal.replace(/\./g, " "),
      );
    }

    this.setState({ currentConversation: waIdHash });
  }
  
  // Called after loadArchive completes to setup listeners
  setupMessageListeners(waid, lastTimestamp = 0) {
    // Idempotent re-bind: avoid duplicate listeners when reopening same conversation
    const refdb = window.firebase.database().ref("conversacion/" + waid);
    refdb.off("child_added");
    refdb.off("child_changed");

    const updatedContactListListener = this.state.contactListListener.filter(
      (listener) => listener !== waid
    );
    if (updatedContactListListener.length !== this.state.contactListListener.length) {
      this.setState({ contactListListener: updatedContactListListener });
    }

    const db = window.firebase.database();
    Actions(this).loadMessages(db, waid, lastTimestamp);
    Actions(this).updateMessages(db, waid);
  }

  cleanupMessageListeners(waid) {
    const db = window.firebase.database();
    
    // Unsubscribe from the listeners for this conversation
    const refdb = db.ref("conversacion/" + waid);
    refdb.off("child_added");
    refdb.off("child_changed");
    
    // Remove from listeners map
    const newListeners = { ...this.state.messageListeners };
    delete newListeners[waid];
    this.setState({ messageListeners: newListeners });
    
    // Remove from contactListListener so listeners can be re-configured for this conversation
    const updatedContactListListener = this.state.contactListListener.filter(
      (listener) => listener !== waid
    );
    this.setState({ contactListListener: updatedContactListListener });
  }

  createBroadcastList(owner, broadcastListName) {
    return Actions(this).createBroadcastList(owner, broadcastListName);
  }

  appendBroadcastListMembers(owner, broadcastList, members) {
    return Actions(this).appendBroadcastListMembers(
      owner,
      broadcastList,
      members,
    );
  }

  loadBroadcastLists(owner) {
    return Actions(this).loadBroadcastLists(owner);
  }

  loadBroadcastListMembers(owner, broadcastList) {
    return Actions(this).loadBroadcastListMembers(owner, broadcastList);
  }

  removeBroadcastListMember(owner, broadcastList, member) {
    return Actions(this).removeBroadcastListMember(
      owner,
      broadcastList,
      member,
    );
  }

  removeBroadcastList(owner, broadcastList) {
    return Actions(this).removeBroadcastList(owner, broadcastList);
  }

  loadArchive(waid) {
    var db = window.firebase.database();

    return Actions(this).loadArchive(waid).then((archivedMessages) => {
      // Set the initial message list with archived messages from database
      this.setState({ messageList: archivedMessages });
      return archivedMessages;
    });
  }

  render() {
    const loaderClass = classNames("col-12 mt-auto mb-auto", {
      hide: !this.state.appIsLoading,
    });

    return (
      <div>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          timeout={1000 * 60 * 40} // 40 minutes
          onIdle={this.handleOnIdle}
          debounce={250}
        />
        <IdleTimer
          ref={(ref) => {
            this.idleTimer2 = ref;
          }}
          timeout={1000 * 60 * 30} // 30 minutes
          onIdle={() => {
            new Notification("Tu sesión está por expirar.", {
              body: "Realiza cualquier movimiento con el cursor para permanecer conectado.",
            });
          }}
          debounce={250}
        />

        <Router>
          <div className="container-fluid" id="main-container">
            <div className="row h-100">
              <div
                className={loaderClass}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100vh",
                  display: this.state.appIsLoading ? "flex" : "none",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  zIndex: 9999,
                }}
              >
                <Spinner intent="primary" size={100} />
                <div className="text-center mt-4">
                  <h5>Consola de atención a clientes por WhatsApp</h5>
                </div>
              </div>

              <ChatListArea
                customerDirectory={this.state.customerDirectory}
                currentAgent={this.state.currentAgent}
                agentImage={this.state.agentImage}
                tenant={this.state.tenant}
                currentConversation={this.state.currentConversation}
                setCurrentConversation={this.setCurrentConversation}
                logOut={this.checkAndClose}
                logIn={this.logIn}
                messageList={this.state.messageList}
                contactList={this.state.contactList}
                quickReplies={this.state.quickReplies}
                typification={this.state.typification}
                templateList={this.state.templateList}
                attentionDays={this.state.attentionDays}
                parameter={this.state.parameter}
                broadcastListList={this.state.broadcastListList}
                createBroadcastList={this.createBroadcastList}
                appendBroadcastListMembers={this.appendBroadcastListMembers}
                loadBroadcastLists={this.loadBroadcastLists}
                loadBroadcastListMembers={this.loadBroadcastListMembers}
                removeBroadcastList={this.removeBroadcastList}
                removeBroadcastListMember={this.removeBroadcastListMember}
                appIsLoading={this.state.appIsLoading}
              />
              <MessageArea
                loadArchive={this.loadArchive}
                setupMessageListeners={this.setupMessageListeners}
                cleanupMessageListeners={this.cleanupMessageListeners}
                currentAgent={this.state.currentAgent}
                currentConversation={this.state.currentConversation}
                setCurrentConversation={this.setCurrentConversation}
                setAgentToConversation={this.setAgentToConversation}
                showDialog={this.showDialog}
                messageList={this.state.messageList}
                contactList={this.state.contactList}
                quickReplies={this.state.quickReplies}
                typification={this.state.typification}
                agentList={this.state.agentList}
                hideConversation={this.hideConversation}
                appIsLoading={this.state.appIsLoading}
                loadingConversation={this.state.loadingConversation}
                setLoadingConversation={(loading) => this.setState({ loadingConversation: loading })}
              />
              <Alert
                icon={this.state.alertMessage.icon}
                confirmButtonText={this.state.alertMessage.okButton}
                isOpen={this.state.alertMessage.isOpen}
                onClose={this.hideAlert}
              >
                <p>{this.state.alertMessage.text}</p>
              </Alert>

              <Toaster
                position={Position.BOTTOM_LEFT}
                ref={this.refHandlers.toaster}
              />
              <Alert
                icon={this.state.alertConversation.icon}
                confirmButtonText={this.state.alertConversation.okButton}
                cancelButtonText={this.state.alertConversation.cancelButton}
                isOpen={this.state.alertConversation.isOpen}
                onConfirm={this.viewTimeOutConv}
                onCancel={this.hideTimeOutConv}
              >
                <p>
                  Existen conversaciones{" "}
                  <b>{this.state.alertConversation.text}</b> <br /> Favor de
                  archivarlas
                </p>
              </Alert>
            </div>
          </div>
        </Router>
      </div>
    );
  }
}
